<template>
  <div class="logout">
    <v-btn icon @click="submit" :title="$t('layouts.login.logout')" style="width: auto;">
      <v-icon>fa fa-sign-out-alt</v-icon>
      <span style="color:#fff; margin-left: 10px;">{{ $t("layouts.login.logout") }}</span>
    </v-btn>    
  </div>
</template>
<script>

import LoginService from "../../services/LoginService";
import { VBtn, VIcon } from 'vuetify/lib';
export default {
  components:{
    VBtn, VIcon
  },
  props: ['oldSystem'],
  methods: {
    clearSessionState() {
      this.$store.commit('setUserName', '');
      this.$store.commit('setUserId', '');
      this.$store.commit('setUser', null);
      this.$store.commit('setHasUnsignedWaiver', null);
      this.$store.commit('setAge18', false);
      this.$store.commit('setUnPaidRegistration', false);
      this.$store.commit('setParticipants', []);
      this.$store.commit('setParticipantsSelected', []);
      try { localStorage.removeItem('select_parts_users'); } catch(e) { /* noop */ }
    },
    async submit() {
      LoginService.logout().then(() => {
        this.clearSessionState();
        if (typeof this.oldSystem === "undefined"){
          this.$router.push({ name: 'Login' });
        } else {
          window.location.href = this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/login?message=You20are%20logged%20out!';
        }
      }).catch(() => {
        this.clearSessionState();
        this.$router.push({ name: 'Login' });
      });
    }
  }
};
</script>

<style scoped>
@media (max-width: 699px){
  .logout {
    margin-right: 0 !important;
    margin-left:10px;
    float: right;
  }
  .logout span{
    content: "";
    display: none;
  }
}
</style>